module.exports = global["jQuery"] = require("-!/Users/amo/dev/elmyra/sources/ip-navigator/node_modules/expose-loader/index.js?$!./jquery.js");